import type {
  IOvieHealthPeakHourDatum,
  IOvieHealthTrendPoint,
} from './analytics-common';

export interface IOvieHealthCallVolumeAnalytics {
  totalCalls: number;
  afterHoursCalls: number;
  repeatCallers: number;
  avgDurationSeconds: number;
  dailyTrend: IOvieHealthTrendPoint[];
  peakHours: IOvieHealthPeakHourDatum[];
}
